var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isTranslated())?_c('BaseGridLayout',{attrs:{"size":"small"}},[_c('section',{staticClass:"col-span-12"},[_c('BaseHeadline',{staticClass:"col-span-full",attrs:{"type":"h1","text":_vm.data.pt_headline,"is-semantic":true}}),_vm._v(" "),_c('BaseToolbarWrapper',[_vm._t("toolbar")],2)],1)]):_c('PageNotTranslated')
}
var staticRenderFns = []

export { render, staticRenderFns }